import { useState } from "react"
import { Form } from "../../ui/ot"
import Staff from "../personal_information_management"

const DepartmentDepthStaffForm = ({
    propsForm,
    onFormFinish = () => { },
}) => {
    const onFinsih = () => {
        onFormFinish()
    }
    const value = Form.useWatch('department_depth_staff_data', propsForm)
    return <>
        <Form
            form={propsForm}
            onFinish={onFinsih}
        >
            <Form.Item
                hidden
                name={'department_depth_id'}
            />
            <Form.Item
                hidden
                name={'department_id'}
            />
            <Staff
                defaultSelectedKeys={(value || [])?.map(item => item.staff_id)}
                defaultSelectedInfo={(value || [])}
                onSelect={(value_, value) => {
                    propsForm.setFieldsValue({ department_depth_staff_data: value.map(item => ({ staff_id: item })) })
                }}
                readonly
            />
        </Form>
    </>
}

export default DepartmentDepthStaffForm